<template>
    <FilterMultiSelect
        :selections="value"
        placeholder="Select State(s)"
        :options="states"
        @handleSelection="$emit('handleValueChange', $event)"
    />
</template>

<script>
import { States } from '@/store/constants';
import FilterMultiSelect from '@/components/common/FilterMultiSelect.vue';

export default {
    components: {
        FilterMultiSelect,
    },
    name: 'StateRule',
    props: ['value'],
    data() {
        return {
            states: States,
        };
    },
};
</script>

<style scoped></style>
